function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom-collections.iterator.js";
import { reaction, runInAction } from "mobx";
import { http, HttpResponse } from "msw";
import { GeomType } from "protomaps-leaflet";
import Cartesian2 from "terriajs-cesium/Source/Core/Cartesian2";
import Cartesian3 from "terriajs-cesium/Source/Core/Cartesian3";
import Color from "terriajs-cesium/Source/Core/Color";
import Iso8601 from "terriajs-cesium/Source/Core/Iso8601";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import createGuid from "terriajs-cesium/Source/Core/createGuid";
import Entity from "terriajs-cesium/Source/DataSources/Entity";
import GeoJsonDataSource from "terriajs-cesium/Source/DataSources/GeoJsonDataSource";
import HeightReference from "terriajs-cesium/Source/Scene/HeightReference";
import StandardCssColors from "../../../../lib/Core/StandardCssColors";
import ContinuousColorMap from "../../../../lib/Map/ColorMap/ContinuousColorMap";
import ProtomapsImageryProvider from "../../../../lib/Map/ImageryProvider/ProtomapsImageryProvider";
import { GEOJSON_SOURCE_LAYER_NAME, ProtomapsGeojsonSource } from "../../../../lib/Map/Vector/Protomaps/ProtomapsGeojsonSource";
import { FEATURE_ID_PROP, getColor } from "../../../../lib/ModelMixins/GeojsonMixin";
import { ImageryParts, isDataSource } from "../../../../lib/ModelMixins/MappableMixin";
import GeoJsonCatalogItem from "../../../../lib/Models/Catalog/CatalogItems/GeoJsonCatalogItem";
import SplitItemReference from "../../../../lib/Models/Catalog/CatalogReferences/SplitItemReference";
import CommonStrata from "../../../../lib/Models/Definition/CommonStrata";
import updateModelFromJson from "../../../../lib/Models/Definition/updateModelFromJson";
import TerriaFeature from "../../../../lib/Models/Feature/Feature";
import { isTerriaFeatureData } from "../../../../lib/Models/Feature/FeatureData";
import Terria from "../../../../lib/Models/Terria";
import { worker } from "../../../mocks/browser";
import verysimpleCzml from "../../../../wwwroot/test/CZML/verysimple.czml" with { type: "json" };
import apiListGeojson from "../../../../wwwroot/test/GeoJSON/api-list.geojson" with { type: "json" };
import apiGeojson from "../../../../wwwroot/test/GeoJSON/api.geojson" with { type: "json" };
import bikeRacksGeojson from "../../../../wwwroot/test/GeoJSON/bike_racks.geojson" with { type: "json" };
import cemeteriesGeojson from "../../../../wwwroot/test/GeoJSON/cemeteries.geojson" with { type: "json" };
import emptyGeomsGeojson from "../../../../wwwroot/test/GeoJSON/empty-geoms.geojson" with { type: "json" };
import gmeGeojson from "../../../../wwwroot/test/GeoJSON/gme.geojson" with { type: "json" };
import heightGeojson from "../../../../wwwroot/test/GeoJSON/height.geojson" with { type: "json" };
import multipointGeojson from "../../../../wwwroot/test/GeoJSON/multipoint.geojson" with { type: "json" };
import multipolygonGeojson from "../../../../wwwroot/test/GeoJSON/multipolygon.geojson" with { type: "json" };
import pointsGeojson from "../../../../wwwroot/test/GeoJSON/points.geojson" with { type: "json" };
import polygonGeojson from "../../../../wwwroot/test/GeoJSON/polygon.geojson" with { type: "json" };
import polylineGeojson from "../../../../wwwroot/test/GeoJSON/polyline.geojson" with { type: "json" };
import timeBasedAutomaticStylesGeojson from "../../../../wwwroot/test/GeoJSON/time-based-automatic-styles.geojson" with { type: "json" };
import timeBasedGeojson from "../../../../wwwroot/test/GeoJSON/time-based.geojson" with { type: "json" };
describe("GeoJsonCatalogItemSpec", () => {
  beforeEach(() => {
    worker.use(http.get("test/GeoJSON/bike_racks.geojson", () => HttpResponse.json(bikeRacksGeojson)), http.get("test/GeoJSON/cemeteries.geojson", () => HttpResponse.json(cemeteriesGeojson)), http.get("test/GeoJSON/gme.geojson", () => HttpResponse.json(gmeGeojson)), http.get("test/CZML/verysimple.czml", () => HttpResponse.json(verysimpleCzml)), http.get("test/GeoJSON/time-based.geojson", () => HttpResponse.json(timeBasedGeojson)), http.get("test/GeoJSON/time-based-automatic-styles.geojson", () => HttpResponse.json(timeBasedAutomaticStylesGeojson)), http.get("test/GeoJSON/height.geojson", () => HttpResponse.json(heightGeojson)), http.get("test/GeoJSON/polyline.geojson", () => HttpResponse.json(polylineGeojson)), http.get("test/GeoJSON/polygon.geojson", () => HttpResponse.json(polygonGeojson)), http.get("test/GeoJSON/api.geojson", () => HttpResponse.json(apiGeojson)), http.get("test/GeoJSON/api-list.geojson", () => HttpResponse.json(apiListGeojson)), http.get("test/GeoJSON/points.geojson", () => HttpResponse.json(pointsGeojson)), http.get("test/GeoJSON/multipoint.geojson", () => HttpResponse.json(multipointGeojson)), http.get("test/GeoJSON/multipolygon.geojson", () => HttpResponse.json(multipolygonGeojson)), http.get("test/GeoJSON/empty-geoms.geojson", () => HttpResponse.json(emptyGeomsGeojson)), http.get("test/KML/vic_police.kml", () => HttpResponse.text("this is not json")));
  });
  describe("- with cesium primitives", function () {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
      geojson.setTrait(CommonStrata.user, "forceCesiumPrimitives", true);
    });
    describe("GeoJsonCatalogItem", function () {
      it("handles features with null geom", async () => {
        var _geojson$readyData;
        geojson.setTrait(CommonStrata.user, "geoJsonData", {
          type: "FeatureCollection",
          features: [{
            type: "Feature",
            properties: {
              LGA_CODE19: "19499",
              LGA_NAME19: "No usual address (NSW)",
              STE_CODE16: "1",
              STE_NAME16: "New South Wales",
              AREASQKM19: 0.0
            },
            geometry: null
          }, {
            type: "Feature",
            properties: {},
            geometry: {
              type: "Polygon",
              coordinates: [[[144.806671142578125, -32.96258644191746], [145.008544921875, -33.19273094190691], [145.557861328125, -32.659031913817685], [145.042877197265625, -32.375322284319346], [144.7998046875, -32.96719522935591], [144.806671142578125, -32.96258644191746]]]
            }
          }]
        });
        await geojson.loadMapItems();
        expect((_geojson$readyData = geojson.readyData) === null || _geojson$readyData === void 0 ? void 0 : _geojson$readyData.features.length).toBe(1);
      });
      it("reloads when the URL is changed", async function () {
        var _entities$values$0$po, _entities$values$0$po2;
        geojson.setTrait(CommonStrata.user, "url", "data:application/json;base64,eyJ0eXBlIjoiRmVhdHVyZUNvbGxlY3Rpb24iLCJmZWF0dXJlcyI6W3sidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7fSwiZ2VvbWV0cnkiOnsidHlwZSI6IlBvaW50IiwiY29vcmRpbmF0ZXMiOlsxNDgsLTMxLjNdfX1dfQ==");
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
        expect((_entities$values$0$po = geojson.mapItems[0].entities.values[0].position) === null || _entities$values$0$po === void 0 || (_entities$values$0$po = _entities$values$0$po.getValue(JulianDate.now())) === null || _entities$values$0$po === void 0 ? void 0 : _entities$values$0$po.equalsEpsilon(Cartesian3.fromDegrees(148.0, -31.3), 0.0001)).toBeTruthy("Doesn't match first location");
        geojson.setTrait(CommonStrata.user, "url", "data:application/json;base64,eyJ0eXBlIjoiRmVhdHVyZUNvbGxlY3Rpb24iLCJmZWF0dXJlcyI6W3sidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7fSwiZ2VvbWV0cnkiOnsidHlwZSI6IlBvaW50IiwiY29vcmRpbmF0ZXMiOlsxNTEsLTMzLjhdfX1dfQ==");
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
        expect((_entities$values$0$po2 = geojson.mapItems[0].entities.values[0].position) === null || _entities$values$0$po2 === void 0 || (_entities$values$0$po2 = _entities$values$0$po2.getValue(JulianDate.now())) === null || _entities$values$0$po2 === void 0 ? void 0 : _entities$values$0$po2.equalsEpsilon(Cartesian3.fromDegrees(151.0, -33.8), 0.0001)).toBeTruthy("Doesn't match updated location");
      });
    });
    describe("loading in EPSG:28356", function () {
      it("works by URL", async function () {
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/bike_racks.geojson");
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
      it("works by string", async function () {
        geojson.setTrait(CommonStrata.user, "geoJsonString", JSON.stringify(bikeRacksGeojson));
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
      it("works by data object", async function () {
        geojson.setTrait(CommonStrata.user, "geoJsonData", bikeRacksGeojson);
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
      it("works with zip", async function () {
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/bike_racks.zip");
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
      /* it("have default dataUrl and dataUrlType", function() {
         geojson.updateFromJson({
           url: "test/GeoJSON/bike_racks.geojson"
         });
         expect(geojson.dataUrl).toBe("test/GeoJSON/bike_racks.geojson");
         expect(geojson.dataUrlType).toBe("direct");
       })
       it("use provided dataUrl", async function() {
         geojson.url = "test/GeoJSON/bike_racks.geojson";
         geojson.dataUrl = "test/test.html";
         geojson.dataUrlType = "fake type";
         await geojson.load();
         expect(geojson.dataSource.entities.values.length).toBeGreaterThan(0);
         expect(geojson.dataUrl).toBe("test/test.html");
         expect(geojson.dataUrlType).toBe("fake type");
       })
        it("works by blob", async function() {
         const blob = await loadBlob("test/GeoJSON/bike_racks.geojson");
         geojson.data = blob;
         geojson.dataSourceUrl = "anything.geojson";
         await geojson.load();
         expect(geojson.dataSource.entities.values.length).toBeGreaterThan(0);
       }); */
    });
    describe("loading in CRS:84", function () {
      it("works by URL", async function () {
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/cemeteries.geojson");
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
      it("works by string", async function () {
        geojson.setTrait(CommonStrata.user, "geoJsonString", JSON.stringify(cemeteriesGeojson));
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
      it("works by blob", async function () {
        geojson.setTrait(CommonStrata.user, "geoJsonData", cemeteriesGeojson);
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
      it("works with zip", async function () {
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/cemeteries.zip");
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
    });
    describe("loading without specified CRS (assumes EPSG:4326)", function () {
      it("works by URL", async function () {
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/gme.geojson");
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
      it("works by string", async function () {
        geojson.setTrait(CommonStrata.user, "geoJsonString", JSON.stringify(gmeGeojson));
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
      it("works by blob", async function () {
        geojson.setTrait(CommonStrata.user, "geoJsonData", gmeGeojson);
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
      it("works with zip", async function () {
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/cemeteries.zip");
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        expect(geojson.mapItems[0].entities.values.length).toBeGreaterThan(0);
        expect(geojson.mapItems[0].entities.values[0].position).toBeDefined();
      });
    });

    // describe('loading Esri-style GeoJSON with an "envelope"', function() {
    //   it("works by URL", async function() {
    //     geojson.setTrait(
    //       CommonStrata.user,
    //       "url",
    //       "test/GeoJSON/EsriEnvelope.geojson"
    //     );
    //     await geojson.loadMapItems();
    //     expect(geojson.mapItems.length).toEqual(1);
    //     expect((geojson.mapItems[0] as GeoJsonDataSource).entities.values.length).toBeGreaterThan(0);
    //     expect((geojson.mapItems[0] as GeoJsonDataSource).entities.values[0].position).toBeDefined();
    //   });
    //
    //   it("works by string", async function() {
    //     const geojsonString = await loadText("test/GeoJSON/EsriEnvelope.geojson");
    //     geojson.setTrait(CommonStrata.user, "geoJsonString", geojsonString);
    //     await geojson.loadMapItems();
    //     expect(geojson.mapItems.length).toEqual(1);
    //     expect((geojson.mapItems[0] as GeoJsonDataSource).entities.values.length).toBeGreaterThan(0);
    //     expect((geojson.mapItems[0] as GeoJsonDataSource).entities.values[0].position).toBeDefined();
    //   });
    //
    //   it("works by blob", async function() {
    //     const blob = await loadJson("test/GeoJSON/EsriEnvelope.geojson");
    //     geojson.setTrait(CommonStrata.user, "geoJsonData", <JsonObject>blob);
    //     await geojson.loadMapItems();
    //     expect(geojson.mapItems.length).toEqual(1);
    //     expect((geojson.mapItems[0] as GeoJsonDataSource).entities.values.length).toBeGreaterThan(0);
    //     expect((geojson.mapItems[0] as GeoJsonDataSource).entities.values[0].position).toBeDefined();
    //   });
    // });

    describe("error handling", function () {
      it("fails gracefully when the data at a URL is not JSON", async () => {
        geojson.setTrait(CommonStrata.user, "url", "test/KML/vic_police.kml");
        const error = (await geojson.loadMapItems()).error;
        expect(error).toBeDefined("Load should not succeed");
      });
      it("fails gracefully when the provided string is not JSON", async () => {
        geojson.setTrait(CommonStrata.user, "geoJsonString", "this is not json");
        const error = (await geojson.loadMapItems()).error;
        expect(error).toBeDefined("Load should not succeed");
      });
      it("fails gracefully when the data at a URL is JSON but not GeoJSON", async () => {
        geojson.setTrait(CommonStrata.user, "url", "test/CZML/verysimple.czml");
        const error = (await geojson.loadMapItems()).error;
        expect(error).toBeDefined("Load should not succeed");
      });
      it("fails gracefully when the provided string is JSON but not GeoJSON", async () => {
        geojson.setTrait(CommonStrata.user, "geoJsonString", JSON.stringify(verysimpleCzml));
        const error = (await geojson.loadMapItems()).error;
        expect(error).toBeDefined("Load should not succeed");
      });
      /*
      it("fails gracefully when the provided blob is JSON but not GeoJSON", function(done) {
        loadBlob("test/CZML/verysimple.czml").then(function(blob) {
          geojson.data = blob;
          geojson.dataSourceUrl = "anything.czml";
          geojson
            .load()
            .then(function() {
              done.fail("Load should not succeed.");
            })
            .catch(function(e) {
              expect(e instanceof TerriaError).toBe(true);
              done();
            });
        });
      }); */
    });

    // describe("Adding and removing attribution", function() {
    //   var currentViewer;
    //   beforeEach(function() {
    //     currentViewer = geojson.terria.currentViewer;
    //     geojson.url = "test/GeoJSON/polygon.topojson";
    //     terria.disclaimerListener = function(member, callback) {
    //       callback();
    //     };
    //     geojson.isEnabled = true;
    //   });

    //   it("can add attribution", async function() {
    //     spyOn(currentViewer, "addAttribution");
    //     geojson.load();
    //     await geojson._loadForEnablePromise;
    //     expect(currentViewer.addAttribution).toHaveBeenCalled();
    //   });

    //   it("can remove attribution", async function() {
    //     spyOn(currentViewer, "removeAttribution");
    //     geojson.load();
    //     await geojson._loadForEnablePromise;
    //     geojson.isEnabled = false;
    //     expect(currentViewer.removeAttribution).toHaveBeenCalled();
    //   });
    // });

    describe("Support for time-varying geojson", () => {
      it("Associates features with discrete times", async () => {
        var _entity1$availability, _entity1$availability2, _entity2$availability, _entity2$availability2;
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/time-based.geojson");
        geojson.setTrait(CommonStrata.user, "timeProperty", "year");
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        const entities = geojson.mapItems[0].entities.values;
        expect(entities.length).toEqual(2);
        const entity1 = entities[0];
        expect((_entity1$availability = entity1.availability) === null || _entity1$availability === void 0 ? void 0 : _entity1$availability.start.equals(JulianDate.fromDate(new Date("2021")))).toBeTruthy();
        expect((_entity1$availability2 = entity1.availability) === null || _entity1$availability2 === void 0 ? void 0 : _entity1$availability2.stop.equals(Iso8601.MAXIMUM_VALUE)).toBeTruthy();
        const entity2 = entities[1];
        expect((_entity2$availability = entity2.availability) === null || _entity2$availability === void 0 ? void 0 : _entity2$availability.start.equals(JulianDate.fromDate(new Date("2019")))).toBeTruthy();
        expect((_entity2$availability2 = entity2.availability) === null || _entity2$availability2 === void 0 ? void 0 : _entity2$availability2.stop.equals(JulianDate.fromDate(new Date("2021")))).toBeTruthy();
      });
    });
    describe("Support for filterByProperties", () => {
      it("Filters correct features", async () => {
        var _entity1$properties;
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/time-based.geojson");
        geojson.setTrait(CommonStrata.user, "filterByProperties", {
          year: 2019
        });
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        const entities = geojson.mapItems[0].entities.values;
        expect(entities.length).toEqual(1);
        const entity1 = entities[0];
        expect((_entity1$properties = entity1.properties) === null || _entity1$properties === void 0 ? void 0 : _entity1$properties.getValue(terria.timelineClock.currentTime).year).toBe(2019);
      });
    });
    describe("Support for geojson with extruded heights", () => {
      it("Sets polygon height properties correctly", async () => {
        var _entity1$polygon, _entity1$polygon2, _entity2$polygon, _entity2$polygon2, _entity2$polygon3;
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/height.geojson");
        geojson.setTrait(CommonStrata.user, "heightProperty", "someProperty");
        await geojson.loadMapItems();
        expect(geojson.mapItems.length).toEqual(1);
        const entities = geojson.mapItems[0].entities.values;
        expect(entities.length).toEqual(2);
        const entity1 = entities[0];
        expect((_entity1$polygon = entity1.polygon) === null || _entity1$polygon === void 0 || (_entity1$polygon = _entity1$polygon.extrudedHeight) === null || _entity1$polygon === void 0 ? void 0 : _entity1$polygon.getValue(terria.timelineClock.currentTime)).toBe(10);
        expect((_entity1$polygon2 = entity1.polygon) === null || _entity1$polygon2 === void 0 || (_entity1$polygon2 = _entity1$polygon2.heightReference) === null || _entity1$polygon2 === void 0 ? void 0 : _entity1$polygon2.getValue(terria.timelineClock.currentTime)).toBe(HeightReference.CLAMP_TO_GROUND);
        const entity2 = entities[1];
        expect((_entity2$polygon = entity2.polygon) === null || _entity2$polygon === void 0 || (_entity2$polygon = _entity2$polygon.extrudedHeight) === null || _entity2$polygon === void 0 ? void 0 : _entity2$polygon.getValue(terria.timelineClock.currentTime)).toBe(20);
        expect((_entity2$polygon2 = entity2.polygon) === null || _entity2$polygon2 === void 0 || (_entity2$polygon2 = _entity2$polygon2.heightReference) === null || _entity2$polygon2 === void 0 ? void 0 : _entity2$polygon2.getValue(terria.timelineClock.currentTime)).toBe(HeightReference.CLAMP_TO_GROUND);
        expect((_entity2$polygon3 = entity2.polygon) === null || _entity2$polygon3 === void 0 || (_entity2$polygon3 = _entity2$polygon3.extrudedHeightReference) === null || _entity2$polygon3 === void 0 ? void 0 : _entity2$polygon3.getValue(terria.timelineClock.currentTime)).toBe(HeightReference.RELATIVE_TO_GROUND);
      });
    });
    describe("Per features styling", function () {
      it("Applies styles to features according to their properties, respecting string case", async function () {
        var _entity$properties;
        const name = "PETER FAGANS GRAVE";
        const fill = "#0000ff";
        runInAction(() => {
          updateModelFromJson(geojson, CommonStrata.override, {
            name: "test",
            type: "geojson",
            url: "test/GeoJSON/cemeteries.geojson",
            perPropertyStyles: [{
              properties: {
                NAME: name
              },
              style: {
                fill: fill
              },
              caseSensitive: true
            }]
          });
        });
        await geojson.loadMapItems();
        const entity = geojson.mapItems[0].entities.values.find(e => {
          var _e$properties;
          return ((_e$properties = e.properties) === null || _e$properties === void 0 ? void 0 : _e$properties.getValue(JulianDate.now()).NAME) === name;
        });
        expect(entity).toBeDefined();
        expect(entity === null || entity === void 0 || (_entity$properties = entity.properties) === null || _entity$properties === void 0 || (_entity$properties = _entity$properties.getValue(JulianDate.now())) === null || _entity$properties === void 0 ? void 0 : _entity$properties.fill).toEqual(fill);
      });
    });
  });
  describe("- with CZML template", function () {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
    });
    describe("Support for czml templates", () => {
      it("supports points", async () => {
        var _entity1$cylinder, _entity1$cylinder2, _entity1$properties2, _entity2$cylinder, _entity2$cylinder2, _entity2$properties;
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/points.geojson");
        geojson.setTrait(CommonStrata.user, "czmlTemplate", {
          cylinder: {
            length: {
              reference: "#properties.height"
            },
            topRadius: {
              reference: "#properties.radius"
            },
            bottomRadius: {
              reference: "#properties.radius"
            },
            material: {
              solidColor: {
                color: {
                  rgba: [0, 200, 0, 20]
                }
              }
            }
          }
        });
        await geojson.loadMapItems();
        const entities = geojson.mapItems[0].entities.values;
        expect(entities.length).toEqual(5);
        const entity1 = entities[0];
        expect((_entity1$cylinder = entity1.cylinder) === null || _entity1$cylinder === void 0 || (_entity1$cylinder = _entity1$cylinder.length) === null || _entity1$cylinder === void 0 ? void 0 : _entity1$cylinder.getValue(terria.timelineClock.currentTime)).toBe("10");
        expect((_entity1$cylinder2 = entity1.cylinder) === null || _entity1$cylinder2 === void 0 || (_entity1$cylinder2 = _entity1$cylinder2.bottomRadius) === null || _entity1$cylinder2 === void 0 ? void 0 : _entity1$cylinder2.getValue(terria.timelineClock.currentTime)).toBe("10");
        expect((_entity1$properties2 = entity1.properties) === null || _entity1$properties2 === void 0 || (_entity1$properties2 = _entity1$properties2.someOtherProp) === null || _entity1$properties2 === void 0 ? void 0 : _entity1$properties2.getValue()).toBe("what");
        const entity2 = entities[1];
        expect((_entity2$cylinder = entity2.cylinder) === null || _entity2$cylinder === void 0 || (_entity2$cylinder = _entity2$cylinder.length) === null || _entity2$cylinder === void 0 ? void 0 : _entity2$cylinder.getValue(terria.timelineClock.currentTime)).toBe("20");
        expect((_entity2$cylinder2 = entity2.cylinder) === null || _entity2$cylinder2 === void 0 || (_entity2$cylinder2 = _entity2$cylinder2.bottomRadius) === null || _entity2$cylinder2 === void 0 ? void 0 : _entity2$cylinder2.getValue(terria.timelineClock.currentTime)).toBe("5");
        expect((_entity2$properties = entity2.properties) === null || _entity2$properties === void 0 || (_entity2$properties = _entity2$properties.someOtherProp) === null || _entity2$properties === void 0 ? void 0 : _entity2$properties.getValue()).toBe("ok");
      });
      it("supports polygons", async () => {
        var _entity1$polygon3, _entity1$properties3, _entity1$properties4;
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/polygon.geojson");
        geojson.setTrait(CommonStrata.user, "czmlTemplate", {
          polygon: {
            height: 10,
            material: {
              solidColor: {
                color: {
                  rgba: [0, 200, 0, 20]
                }
              }
            }
          }
        });
        await geojson.loadMapItems();
        const entities = geojson.mapItems[0].entities.values;
        expect(entities.length).toEqual(1);
        const entity1 = entities[0];
        expect((_entity1$polygon3 = entity1.polygon) === null || _entity1$polygon3 === void 0 || (_entity1$polygon3 = _entity1$polygon3.height) === null || _entity1$polygon3 === void 0 ? void 0 : _entity1$polygon3.getValue(terria.timelineClock.currentTime)).toBe(10);
        expect((_entity1$properties3 = entity1.properties) === null || _entity1$properties3 === void 0 || (_entity1$properties3 = _entity1$properties3.foo) === null || _entity1$properties3 === void 0 ? void 0 : _entity1$properties3.getValue()).toBe("hi");
        expect((_entity1$properties4 = entity1.properties) === null || _entity1$properties4 === void 0 || (_entity1$properties4 = _entity1$properties4.bar) === null || _entity1$properties4 === void 0 ? void 0 : _entity1$properties4.getValue()).toBe("bye");
      });
    });
  });
  describe("- tablestyling - with geojson-vt and protomaps", function () {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
    });
    it("Creates ProtomapsImageryProvider - with table styles", async () => {
      var _geojson$activeTableS;
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/height.geojson");
      await geojson.loadMapItems();
      const mapItem = geojson.mapItems[0];
      expect("imageryProvider" in mapItem && mapItem.imageryProvider instanceof ProtomapsImageryProvider).toBeTruthy();
      const protomaps = "imageryProvider" in mapItem ? mapItem.imageryProvider : undefined;
      if (!protomaps) throw "protomaps should be defined";
      expect(geojson.activeStyle).toBe("someProperty");
      expect((_geojson$activeTableS = geojson.activeTableStyle.colorColumn) === null || _geojson$activeTableS === void 0 ? void 0 : _geojson$activeTableS.name).toBe("someProperty");
      expect(geojson.activeTableStyle.tableColorMap.minimumValue).toBe(10);
      expect(geojson.activeTableStyle.tableColorMap.maximumValue).toBe(20);
      expect(geojson.activeTableStyle.tableColorMap.colorMap instanceof ContinuousColorMap).toBeTruthy();
      const polygonSymbol = protomaps.paintRules[0].symbolizer;
      const polylineSymbol = protomaps.paintRules[1].symbolizer;
      const testFeature = {
        props: {},
        geomType: GeomType.Polygon,
        numVertices: 0,
        geom: [],
        bbox: {
          minX: 0,
          minY: 0,
          maxX: 0,
          maxY: 0
        }
      };
      const rowIdToColor = [[0, "rgb(255,245,240)"], [1, "rgb(103,0,13)"]];
      rowIdToColor.forEach(_ref => {
        var _geojson$activeTableS2, _geojson$activeTableS3, _geojson$activeTableS4;
        let [rowId, col] = _ref;
        expect((_geojson$activeTableS2 = geojson.activeTableStyle.colorMap.mapValueToColor((_geojson$activeTableS3 = geojson.activeTableStyle.colorColumn) === null || _geojson$activeTableS3 === void 0 || (_geojson$activeTableS3 = _geojson$activeTableS3.valuesForType) === null || _geojson$activeTableS3 === void 0 ? void 0 : _geojson$activeTableS3[rowId])) === null || _geojson$activeTableS2 === void 0 ? void 0 : _geojson$activeTableS2.toCssColorString()).toBe(col);
        expect(polygonSymbol.fill.get(1, _objectSpread(_objectSpread({}, testFeature), {}, {
          geomType: GeomType.Polygon,
          props: {
            _id_: rowId
          }
        }))).toBe(col);
        expect(polygonSymbol.stroke.get(1, _objectSpread(_objectSpread({}, testFeature), {}, {
          geomType: GeomType.Polygon,
          props: {
            _id_: rowId
          }
        }))).toBe(getColor(terria.baseMapContrastColor).toCssHexString());
        expect(polygonSymbol.width.get(1, _objectSpread(_objectSpread({}, testFeature), {}, {
          geomType: GeomType.Polygon,
          props: {
            _id_: rowId
          }
        }))).toBe((_geojson$activeTableS4 = geojson.activeTableStyle.outlineStyleMap.traitValues.null.width) !== null && _geojson$activeTableS4 !== void 0 ? _geojson$activeTableS4 : Infinity);
        expect(polylineSymbol.color.get(1, _objectSpread(_objectSpread({}, testFeature), {}, {
          geomType: GeomType.Line,
          props: {
            _id_: rowId
          }
        }))).toBe(col);
      });
    });
    it("Creates table features for points", async () => {
      var _geojson$activeTableS5, _mapItem$entities$val, _mapItem$entities$val2;
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/bike_racks.geojson");
      await geojson.loadMapItems();
      const mapItem = geojson.mapItems[0];
      expect(isDataSource(mapItem)).toBeTruthy();
      expect(geojson.activeStyle).toBe("number_of_");
      expect((_geojson$activeTableS5 = geojson.activeTableStyle.colorColumn) === null || _geojson$activeTableS5 === void 0 ? void 0 : _geojson$activeTableS5.name).toBe("number_of_");
      expect(geojson.activeTableStyle.tableColorMap.minimumValue).toBe(0);
      expect(geojson.activeTableStyle.tableColorMap.maximumValue).toBe(20);
      expect(geojson.activeTableStyle.tableColorMap.colorMap instanceof ContinuousColorMap).toBeTruthy();

      // Test some colors
      expect((_mapItem$entities$val = mapItem.entities.values[10].point) === null || _mapItem$entities$val === void 0 || (_mapItem$entities$val = _mapItem$entities$val.color) === null || _mapItem$entities$val === void 0 || (_mapItem$entities$val = _mapItem$entities$val.getValue(terria.timelineClock.currentTime)) === null || _mapItem$entities$val === void 0 ? void 0 : _mapItem$entities$val.toCssColorString()).toBe("rgb(254,227,214)");
      expect((_mapItem$entities$val2 = mapItem.entities.values[20].point) === null || _mapItem$entities$val2 === void 0 || (_mapItem$entities$val2 = _mapItem$entities$val2.color) === null || _mapItem$entities$val2 === void 0 || (_mapItem$entities$val2 = _mapItem$entities$val2.getValue(terria.timelineClock.currentTime)) === null || _mapItem$entities$val2 === void 0 ? void 0 : _mapItem$entities$val2.toCssColorString()).toBe("rgb(103,0,13)");
      expect(geojson.disableSplitter).toBeTruthy();
    });
    it("Supports LegendOwnerTraits to override TableMixin.legends", async () => {
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/height.geojson");
      await geojson.loadMapItems();
      expect("imageryProvider" in geojson.mapItems[0] && geojson.mapItems[0].imageryProvider instanceof ProtomapsImageryProvider).toBeTruthy();
      expect(geojson.legends.length).toBe(1);
      expect(geojson.legends[0].items.map(i => i.color)).toEqual(["rgb(103,0,13)", "rgb(176,18,24)", "rgb(226,48,40)", "rgb(249,105,76)", "rgb(252,160,130)", "rgb(253,211,193)", "rgb(255,245,240)"]);
      runInAction(() => updateModelFromJson(geojson, CommonStrata.definition, {
        legends: [{
          url: "some-url"
        }]
      }));
      expect(geojson.legends.length).toBe(1);
      expect(geojson.legends[0].url).toBe("some-url");
    });
    it("Supports LegendOwnerTraits to override TableMixin.legends - with style disabled", async () => {
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/height.geojson");
      await geojson.loadMapItems();
      runInAction(() => {
        expect("imageryProvider" in geojson.mapItems[0] && geojson.mapItems[0].imageryProvider instanceof ProtomapsImageryProvider).toBeTruthy();
        geojson.setTrait("user", "activeStyle", "");
        expect(geojson.legends.length).toBe(1);
        expect(geojson.legends[0].items.length).toBe(1);
        expect(geojson.legends[0].items.map(i =>
        // Look through default colors for disabled styles
        // This can change, as `createColorForIdTransformer` will use the least used color (to avoid clashes)
        !!StandardCssColors.modifiedBrewer8ClassSet2.find(c => Color.fromCssColorString(c).toCssColorString() === i.color))).toEqual([true]);
        updateModelFromJson(geojson, CommonStrata.definition, {
          legends: [{
            url: "some-url"
          }]
        });
        expect(geojson.legends.length).toBe(1);
        expect(geojson.legends[0].url).toBe("some-url");
      });
    });
    it("correctly builds `Feature` from picked Entity", function () {
      const picked = new Entity();
      const feature = geojson.buildFeatureFromPickResult(Cartesian2.ZERO, picked);
      expect(feature).toBeDefined();
      if (feature) {
        expect(feature.cesiumEntity).toBe(picked);
      }
    });
  });
  describe("Disables protomaps (mvt) if geoJson simple styling is detected", () => {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
    });
    it("Unchanged - less than 50% features detected", async () => {
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/api.geojson");
      geojson.setTrait(CommonStrata.user, "geoJsonString", "{\"type\":\"FeatureCollection\",\"features\":[{\"type\":\"Feature\",\"properties\":{\"stroke\":\"#555555\",\"stroke-width\":2,\"stroke-opacity\":1,\"fill\":\"#ff0051\",\"fill-opacity\":0.5},\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[35.859375,53.54030739150022],[11.25,40.17887331434696],[15.1171875,14.604847155053898],[53.4375,44.84029065139799],[35.859375,53.54030739150022]]]}},{\"type\":\"Feature\",\"properties\":{},\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[85.4296875,66.93006025862448],[53.4375,43.83452678223682],[89.296875,34.88593094075317],[91.40625,50.958426723359935],[85.4296875,66.93006025862448]]]}},{\"type\":\"Feature\",\"properties\":{},\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[119.17968749999999,66.79190947341796],[100.1953125,53.74871079689897],[109.3359375,47.517200697839414],[119.17968749999999,66.79190947341796]]]}},{\"type\":\"Feature\",\"properties\":{},\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[71.015625,-2.811371193331128],[99.49218749999999,-2.811371193331128],[99.49218749999999,18.646245142670608],[71.015625,18.646245142670608],[71.015625,-2.811371193331128]]]}},{\"type\":\"Feature\",\"properties\":{},\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[140.9765625,19.642587534013032],[134.296875,-17.978733095556155],[88.9453125,-36.597889133070204],[119.53125,15.961329081596647],[130.078125,27.371767300523047]]}}]}");
      await geojson.loadMapItems();
      expect(geojson.mapItems[0] instanceof GeoJsonDataSource).toBeFalsy();
      expect(geojson.useTableStylingAndProtomaps).toBeTruthy();
      expect(geojson.legends.length).toBe(1);
      expect(geojson.disableSplitter).toBeFalsy();
    });
    it("Disabled protomaps - More than 50% features detected", async () => {
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/api.geojson");
      geojson.setTrait(CommonStrata.user, "geoJsonString", "{\"type\":\"FeatureCollection\",\"features\":[{\"type\":\"Feature\",\"properties\":{\"stroke\":\"#555555\",\"stroke-width\":2,\"stroke-opacity\":1,\"fill\":\"#ff0051\",\"fill-opacity\":0.5},\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[35.859375,53.54030739150022],[11.25,40.17887331434696],[15.1171875,14.604847155053898],[53.4375,44.84029065139799],[35.859375,53.54030739150022]]]}},{\"type\":\"Feature\",\"properties\":{},\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[85.4296875,66.93006025862448],[53.4375,43.83452678223682],[89.296875,34.88593094075317],[91.40625,50.958426723359935],[85.4296875,66.93006025862448]]]}},{\"type\":\"Feature\",\"properties\":{},\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[119.17968749999999,66.79190947341796],[100.1953125,53.74871079689897],[109.3359375,47.517200697839414],[119.17968749999999,66.79190947341796]]]}},{\"type\":\"Feature\",\"properties\":{\"marker-color\":\"#e000ff\",\"marker-size\":\"large\"},\"geometry\":{\"type\":\"Point\",\"coordinates\":[30.585937499999996,-2.108898659243126]}},{\"type\":\"Feature\",\"properties\":{\"stroke\":\"#feff00\",\"stroke-width\":4,\"stroke-opacity\":1,\"fill\":\"#fcffff\",\"fill-opacity\":0.5},\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[71.015625,-2.811371193331128],[99.49218749999999,-2.811371193331128],[99.49218749999999,18.646245142670608],[71.015625,18.646245142670608],[71.015625,-2.811371193331128]]]}},{\"type\":\"Feature\",\"properties\":{\"stroke\":\"#00ff02\",\"stroke-width\":2,\"stroke-opacity\":1},\"geometry\":{\"type\":\"LineString\",\"coordinates\":[[140.9765625,19.642587534013032],[134.296875,-17.978733095556155],[88.9453125,-36.597889133070204],[119.53125,15.961329081596647],[130.078125,27.371767300523047]]}}]}");
      await geojson.loadMapItems();
      expect(geojson.mapItems[0] instanceof GeoJsonDataSource).toBeTruthy();
      expect(geojson.useTableStylingAndProtomaps).toBeFalsy();
      expect(geojson.legends.length).toBe(0);
      expect(geojson.disableSplitter).toBeTruthy();
    });
    it("correctly matches feature _id_ with table rowId - with features with empty geoms", async () => {
      var _geojson$readyData2, _geojson$readyData3, _geojson$readyData4, _geojson$tableColumns;
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/empty-geoms.geojson");
      await geojson.loadMapItems();
      expect((_geojson$readyData2 = geojson.readyData) === null || _geojson$readyData2 === void 0 ? void 0 : _geojson$readyData2.features.length).toBe(4);
      // Check _id_ vs rowIds
      expect((_geojson$readyData3 = geojson.readyData) === null || _geojson$readyData3 === void 0 ? void 0 : _geojson$readyData3.features.map(f => {
        var _f$properties;
        return (_f$properties = f.properties) === null || _f$properties === void 0 ? void 0 : _f$properties[FEATURE_ID_PROP];
      })).toEqual(geojson.rowIds);
      // Check "someOtherProp" column
      expect((_geojson$readyData4 = geojson.readyData) === null || _geojson$readyData4 === void 0 ? void 0 : _geojson$readyData4.features.map(f => {
        var _f$properties2;
        return (_f$properties2 = f.properties) === null || _f$properties2 === void 0 ? void 0 : _f$properties2.someOtherProp;
      })).toEqual((_geojson$tableColumns = geojson.tableColumns.find(c => c.name === "someOtherProp")) === null || _geojson$tableColumns === void 0 ? void 0 : _geojson$tableColumns.values);
    });
    it("correctly matches feature _id_ with table rowId - with filterByProperties", async () => {
      var _geojson$readyData5, _geojson$readyData6;
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/time-based.geojson");
      geojson.setTrait(CommonStrata.user, "filterByProperties", {
        year: 2019
      });
      await geojson.loadMapItems();
      expect((_geojson$readyData5 = geojson.readyData) === null || _geojson$readyData5 === void 0 ? void 0 : _geojson$readyData5.features.length).toBe(1);
      expect((_geojson$readyData6 = geojson.readyData) === null || _geojson$readyData6 === void 0 ? void 0 : _geojson$readyData6.features.map(f => {
        var _f$properties3;
        return (_f$properties3 = f.properties) === null || _f$properties3 === void 0 ? void 0 : _f$properties3[FEATURE_ID_PROP];
      })).toEqual(geojson.rowIds);
    });
    it("supports time", async function () {
      var _geojson$activeTableS6;
      geojson.setTrait(CommonStrata.definition, "url", "test/GeoJSON/time-based-automatic-styles.geojson");
      updateModelFromJson(geojson, CommonStrata.definition, {
        currentTime: "2018-01-01",
        defaultStyle: {
          time: {
            timeColumn: "date",
            idColumns: ["idProperty"]
          }
        }
      });
      const observeMapItems = reaction(() => [geojson.mapItems], () => {});
      (await geojson.loadMapItems()).throwIfError();
      expect((_geojson$activeTableS6 = geojson.activeTableStyle.timeColumn) === null || _geojson$activeTableS6 === void 0 ? void 0 : _geojson$activeTableS6.name).toBe("date");
      const firstProtomapsImageryProvider = "imageryProvider" in geojson.mapItems[0] ? geojson.mapItems[0].imageryProvider : undefined;
      if (!firstProtomapsImageryProvider) throw "protomaps should be defined";
      const testFeature = {
        props: {},
        geomType: GeomType.Polygon,
        numVertices: 0,
        geom: [],
        bbox: {
          minX: 0,
          minY: 0,
          maxX: 0,
          maxY: 0
        }
      };
      const firstFilter = firstProtomapsImageryProvider.paintRules[0].filter;
      if (!firstFilter) {
        throw "filter should be defined";
      }

      // Current time is 2018-01-01
      // First feature maps to 2018-01-01
      testFeature.props = {
        [FEATURE_ID_PROP]: 0
      };
      expect(firstFilter(0, testFeature)).toBeTruthy();

      // Second feature maps to 2019-01-01
      testFeature.props = {
        [FEATURE_ID_PROP]: 1
      };
      expect(firstFilter(0, testFeature)).toBeFalsy();

      // Change time to 2019-01-01
      geojson.setTrait(CommonStrata.definition, "currentTime", "2019-01-01");

      // Check new imagery provider
      const nextProtomapsImageryProvider = "imageryProvider" in geojson.mapItems[0] ? geojson.mapItems[0].imageryProvider : undefined;
      if (!nextProtomapsImageryProvider) throw "protomaps should be defined";
      const nextFilter = nextProtomapsImageryProvider.paintRules[0].filter;
      if (!nextFilter) {
        throw "filter should be defined";
      }
      testFeature.props = {
        [FEATURE_ID_PROP]: 0
      };
      expect(nextFilter(0, testFeature)).toBeFalsy();
      testFeature.props = {
        [FEATURE_ID_PROP]: 1
      };
      expect(nextFilter(0, testFeature)).toBeTruthy();
      expect(firstProtomapsImageryProvider === nextProtomapsImageryProvider).toBeFalsy();

      // Now change the currentTime to 2019- g01-02 - this should not trigger a new imagery provider - as it within the current time interval
      geojson.setTrait(CommonStrata.definition, "currentTime", "2019-01-02");

      // Check new imagery provider
      const lastProtomapsImageryProvider = "imageryProvider" in geojson.mapItems[0] ? geojson.mapItems[0].imageryProvider : undefined;
      if (!lastProtomapsImageryProvider) throw "protomaps should be defined";
      expect(nextProtomapsImageryProvider === lastProtomapsImageryProvider).toBeTruthy();
      observeMapItems();
    });
  });
  describe("Support geojson through apis", () => {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
    });
    it("Extracts geojson nested in a json object", async () => {
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/api.geojson");
      geojson.setTrait(CommonStrata.user, "responseDataPath", "nested.data");
      await geojson.loadMapItems();
      expect(geojson.mapItems.length).toEqual(1);
    });
    it("Extracts geojson from an array of json objects", async () => {
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/api-list.geojson");
      geojson.setTrait(CommonStrata.user, "responseGeoJsonPath", "nested.data");
      await geojson.loadMapItems();
      expect(geojson.mapItems.length).toEqual(1);
    });
  });
  describe("When given multiple URLs", function () {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
      geojson.setTrait(CommonStrata.user, "forceCesiumPrimitives", true);
    });
    it("fetches and merges the responses as a single geojson feature collection", async function () {
      updateModelFromJson(geojson, CommonStrata.user, {
        urls: [{
          url: "test/GeoJSON/api.geojson",
          responseDataPath: "nested.data"
        }, {
          url: "test/GeoJSON/points.geojson"
        }]
      });
      await geojson.loadMapItems();
      expect(geojson.mapItems.length).toEqual(1);
      const mapItem = geojson.mapItems[0];
      expect(isDataSource(mapItem)).toBeTruthy();
      expect(mapItem.entities.values.length).toBe(7);
    });
  });
  describe("handling MultiPoint features", function () {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/multipoint.geojson");
    });
    it("explodes multipoints as points", async function () {
      await geojson.loadMapItems();
      const points = geojson.mapItems[0];
      expect(points).toBeDefined();
      expect(isDataSource(points)).toBeTruthy();
      expect(points.entities.values.length).toEqual(5);
    });
  });
  describe("handling MultiPolygon features", function () {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/multipolygon.geojson");
    });
    it("creates multi-polygon cesium primitives features", async function () {
      runInAction(() => geojson.setTrait(CommonStrata.user, "forceCesiumPrimitives", true));
      await geojson.loadMapItems();
      const features = geojson.mapItems[0];
      expect(features).toBeDefined();
      expect(isDataSource(features)).toBeTruthy();
      expect(features.entities.values.length).toEqual(5);
      expect(features.entities.values[0].polygon).toBeDefined();
      expect(features.entities.values[1].polygon).toBeDefined();
      expect(features.entities.values[2].polygon).toBeDefined();
      expect(features.entities.values[3].polyline).toBeDefined();
      expect(features.entities.values[4].polyline).toBeDefined();
    });
  });
  describe("ProtomapsGeojsonSource", function () {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
    });
    it("creates multi-polygon protomaps features", async function () {
      var _features$get, _features$get2;
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/multipolygon.geojson");
      geojson.setTrait(CommonStrata.user, "forceCesiumPrimitives", false);
      await geojson.loadMapItems();
      const imageryParts = geojson.mapItems[0];
      expect(imageryParts).toBeDefined();
      expect(ImageryParts.is(imageryParts)).toBeTruthy();
      const imageryProvider = imageryParts.imageryProvider;
      expect(imageryProvider instanceof ProtomapsImageryProvider).toBeTruthy();
      const source = imageryProvider.source;
      expect(source instanceof ProtomapsGeojsonSource).toBeTruthy();
      const features = await source.get({
        x: 23,
        y: 35,
        z: 6
      }, 256);
      expect((_features$get = features.get(GEOJSON_SOURCE_LAYER_NAME)) === null || _features$get === void 0 ? void 0 : _features$get.length).toEqual(1);
      const feature = (_features$get2 = features.get(GEOJSON_SOURCE_LAYER_NAME)) === null || _features$get2 === void 0 ? void 0 : _features$get2[0];
      expect(feature === null || feature === void 0 ? void 0 : feature.geom.length).toEqual(4);
      expect(feature === null || feature === void 0 ? void 0 : feature.bbox).toEqual({
        maxX: 288,
        maxY: 204.3125,
        minX: -32,
        minY: -32
      });
    });
    it("creates polygon protomaps features", async function () {
      var _features$get3, _features$get4, _feature$geom, _feature$geom2, _feature$props;
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/polygon.geojson");
      await geojson.loadMapItems();
      const imageryParts = geojson.mapItems[0];
      expect(imageryParts).toBeDefined();
      expect(ImageryParts.is(imageryParts)).toBeTruthy();
      const imageryProvider = imageryParts.imageryProvider;
      expect(imageryProvider instanceof ProtomapsImageryProvider).toBeTruthy();
      const source = imageryProvider.source;
      expect(source instanceof ProtomapsGeojsonSource).toBeTruthy();
      const features = await source.get({
        x: 798,
        y: 510,
        z: 10
      }, 256);
      expect((_features$get3 = features.get(GEOJSON_SOURCE_LAYER_NAME)) === null || _features$get3 === void 0 ? void 0 : _features$get3.length).toEqual(1);
      const feature = (_features$get4 = features.get(GEOJSON_SOURCE_LAYER_NAME)) === null || _features$get4 === void 0 ? void 0 : _features$get4[0];
      expect(feature === null || feature === void 0 ? void 0 : feature.geom.length).toEqual(2);
      expect(feature === null || feature === void 0 || (_feature$geom = feature.geom) === null || _feature$geom === void 0 ? void 0 : _feature$geom[0].length).toEqual(5);
      expect(feature === null || feature === void 0 || (_feature$geom2 = feature.geom) === null || _feature$geom2 === void 0 ? void 0 : _feature$geom2[1].length).toEqual(5);
      expect(feature === null || feature === void 0 ? void 0 : feature.bbox).toEqual({
        maxX: 288,
        maxY: 288,
        minX: -32,
        minY: -32
      });
      expect(feature === null || feature === void 0 || (_feature$props = feature.props) === null || _feature$props === void 0 ? void 0 : _feature$props.bar).toEqual("bye");
    });
    it("creates polyline protomaps features", async function () {
      var _features$get5, _features$get6, _feature$geom3;
      geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/polyline.geojson");
      geojson.setTrait(CommonStrata.user, "forceCesiumPrimitives", false);
      await geojson.loadMapItems();
      const imageryParts = geojson.mapItems[0];
      expect(imageryParts).toBeDefined();
      expect(ImageryParts.is(imageryParts)).toBeTruthy();
      const imageryProvider = imageryParts.imageryProvider;
      expect(imageryProvider instanceof ProtomapsImageryProvider).toBeTruthy();
      const source = imageryProvider.source;
      expect(source instanceof ProtomapsGeojsonSource).toBeTruthy();
      const features = await source.get({
        x: 798,
        y: 510,
        z: 10
      }, 256);
      expect((_features$get5 = features.get(GEOJSON_SOURCE_LAYER_NAME)) === null || _features$get5 === void 0 ? void 0 : _features$get5.length).toEqual(1);
      const feature = (_features$get6 = features.get(GEOJSON_SOURCE_LAYER_NAME)) === null || _features$get6 === void 0 ? void 0 : _features$get6[0];
      expect(feature === null || feature === void 0 ? void 0 : feature.geom.length).toEqual(1);
      expect(feature === null || feature === void 0 || (_feature$geom3 = feature.geom) === null || _feature$geom3 === void 0 ? void 0 : _feature$geom3[0].length).toEqual(2);
      expect(feature === null || feature === void 0 ? void 0 : feature.bbox).toEqual({
        maxX: 145.75,
        maxY: 145.75,
        minX: -32,
        minY: -32
      });
    });
  });
  describe("geojson can be split", function () {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
    });
    it("protomaps-mvt - polygons/lines", async function () {
      terria.addModel(geojson);
      geojson.setTrait(CommonStrata.user, "geoJsonString", JSON.stringify(timeBasedGeojson));
      await geojson.loadMapItems();
      expect(geojson.disableSplitter).toBeFalsy();
      const split = new SplitItemReference(createGuid(), terria);
      split.setTrait(CommonStrata.definition, "splitSourceItemId", geojson.uniqueId);
      const loadReferenceResult = await split.loadReference();
      expect(loadReferenceResult.error).toBeUndefined();
      expect(split.target instanceof GeoJsonCatalogItem).toBeTruthy();
      expect((await split.target.loadMapItems()).error).toBeUndefined();
    });
    it("cesium - points - splitter disabled", async function () {
      terria.addModel(geojson);
      geojson.setTrait(CommonStrata.user, "geoJsonString", JSON.stringify(cemeteriesGeojson));
      await geojson.loadMapItems();
      expect(geojson.disableSplitter).toBeTruthy();
    });
  });
  describe("geojson handles reprojection", function () {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
    });
    it("feature collection", async function () {
      geojson.setTrait(CommonStrata.user, "geoJsonString", "{\n          \"type\": \"FeatureCollection\",\n          \"features\": [\n            {\n              \"type\": \"Feature\",\n              \"id\": \"DigitalEarthAustraliaWaterbodies_v2.323183\",\n              \"geometry\": {\n                \"type\": \"MultiPolygon\",\n                \"coordinates\": [\n                  [\n                    [\n                      [\n                        16344453.39652363,\n                        -5168812.43146947\n                      ],\n                      [\n                        16344531.47850556,\n                        -5168802.80795983\n                      ],\n                      [\n                        16344545.13149061,\n                        -5168926.64661882\n                      ],\n                      [\n                        16344506.09019498,\n                        -5168931.45855288\n                      ],\n                      [\n                        16344510.64113426,\n                        -5168972.73862808\n                      ],\n                      [\n                        16344471.59970792,\n                        -5168977.55049352\n                      ],\n                      [\n                        16344453.39652363,\n                        -5168812.43146947\n                      ]\n                    ]\n                  ]\n                ]\n              }\n            }\n          ],\n          \"crs\": {\n            \"type\": \"name\",\n            \"properties\": {\n              \"name\": \"urn:ogc:def:crs:EPSG::3857\"\n            }\n          }\n        }");
      await geojson.loadMapItems();
      expect(geojson.readyData).toEqual({
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          id: "DigitalEarthAustraliaWaterbodies_v2.323183",
          geometry: {
            type: "MultiPolygon",
            coordinates: [[[[146.82472296676403, -42.05226984176366], [146.82542438914183, -42.0522056500624], [146.8255470359933, -42.053031686178954], [146.8251963220675, -42.05306378281588], [146.82523720385066, -42.053339129144845], [146.8248864887507, -42.05337122516867], [146.82472296676403, -42.05226984176366]]]]
          },
          properties: {
            _id_: 0
          }
        }],
        crs: {
          type: "EPSG",
          properties: {
            code: "4326"
          }
        }
      });
    });
    it("feature", async function () {
      geojson.setTrait(CommonStrata.user, "geoJsonString", "{\n          \"type\": \"Feature\",\n          \"id\": \"DigitalEarthAustraliaWaterbodies_v2.308678\",\n          \"geometry\": {\n              \"type\": \"MultiPolygon\",\n              \"coordinates\": [\n                  [\n                      [\n                          [\n                              16465357.77780054,\n                              -4492530.25036082\n                          ],\n                          [\n                              16465432.27212674,\n                              -4492520.79949369\n                          ],\n                          [\n                              16465441.59842631,\n                              -4492596.29102978\n                          ],\n                          [\n                              16465367.10371601,\n                              -4492605.74203159\n                          ],\n                          [\n                              16465357.77780054,\n                              -4492530.25036082\n                          ]\n                      ]\n                  ]\n              ]\n          },\n          \"crs\": {\n              \"type\": \"name\",\n              \"properties\": {\n                  \"name\": \"urn:ogc:def:crs:EPSG::3857\"\n              }\n          }\n      }");
      await geojson.loadMapItems();
      expect(geojson.readyData).toEqual({
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          id: "DigitalEarthAustraliaWaterbodies_v2.308678",
          geometry: {
            type: "MultiPolygon",
            coordinates: [[[[147.91082550294465, -37.38230684638059], [147.9114946968627, -37.382239385753564], [147.91157847643717, -37.38277824533993], [147.9109092790687, -37.382845706443504], [147.91082550294465, -37.38230684638059]]]]
          },
          properties: {
            _id_: 0
          }
        }],
        crs: {
          type: "EPSG",
          properties: {
            code: "4326"
          }
        }
      });
    });
  });
  describe("pick features", function () {
    let terria;
    let geojson;
    beforeEach(function () {
      terria = new Terria({
        baseUrl: "./"
      });
      geojson = new GeoJsonCatalogItem("test-geojson", terria);
    });
    it("ProtomapsImageryProvider.createHighlightImageryProvider", async function () {
      geojson.setTrait(CommonStrata.definition, "geoJsonString", "{\"type\":\"FeatureCollection\",\"features\":[{\"type\":\"Feature\",\"properties\":{},\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[145.5908203125,-40.17887331434695],[143.349609375,-42.08191667830631],[146.35986328124997,-44.040218713142124],[149.08447265625,-42.859859815062784],[148.55712890625,-41.36031866306708],[145.5908203125,-40.17887331434695]]]}},{\"type\":\"Feature\",\"properties\":{},\"geometry\":{\"type\":\"Polygon\",\"coordinates\":[[[75.9375,51.069016659603896],[59.94140624999999,39.095962936305476],[79.453125,42.032974332441405],[80.15625,46.800059446787316],[75.673828125,51.45400691005982],[75.9375,51.069016659603896]]]}}]}");
      (await geojson.loadMapItems()).throwIfError();
      const imagery = geojson.mapItems[0];
      if ("imageryProvider" in imagery && imagery.imageryProvider instanceof ProtomapsImageryProvider) {
        const highlight = imagery.imageryProvider.createHighlightImageryProvider(new TerriaFeature({
          properties: {
            [FEATURE_ID_PROP]: "0"
          }
        }));
        expect(highlight).toBeDefined();
        expect(highlight === null || highlight === void 0 ? void 0 : highlight.paintRules[0].dataLayer).toBe(GEOJSON_SOURCE_LAYER_NAME);
      } else {
        throw "Invalid geojson.mapItems";
      }
    });
    it("ProtomapsImageryProvider pickFeatures", async function () {
      var _await$pickFeatures;
      const geojsonData = {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          properties: {},
          geometry: {
            type: "Polygon",
            coordinates: [[[145.5908203125, -40.17887331434695], [143.349609375, -42.08191667830631], [146.35986328124997, -44.040218713142124], [149.08447265625, -42.859859815062784], [148.55712890625, -41.36031866306708], [145.5908203125, -40.17887331434695]]]
          }
        }, {
          type: "Feature",
          properties: {},
          geometry: {
            type: "Polygon",
            coordinates: [[[75.9375, 51.069016659603896], [59.94140624999999, 39.095962936305476], [79.453125, 42.032974332441405], [80.15625, 46.800059446787316], [75.673828125, 51.45400691005982], [75.9375, 51.069016659603896]]]
          }
        }]
      };
      geojson.setTrait(CommonStrata.definition, "geoJsonString", JSON.stringify(geojsonData));
      (await geojson.loadMapItems()).throwIfError();
      const imagery = geojson.mapItems[0];
      expect(imagery.imageryProvider instanceof ProtomapsImageryProvider).toBeTruthy();
      const spyOnProcessPickedFeatures = spyOn(imagery.imageryProvider, "pickFeatures").and.callThrough();
      const features = (_await$pickFeatures = await imagery.imageryProvider.pickFeatures(1, 1, 3, 1.2946797849754814, 0.7826107094181278)) !== null && _await$pickFeatures !== void 0 ? _await$pickFeatures : [];
      expect(spyOnProcessPickedFeatures).toHaveBeenCalledTimes(1);
      expect(features.length).toBe(1);
      expect(features[0].data.geometry).toEqual(geojsonData.features[1].geometry);
    });
    it("ProtomapsImageryProvider pickFeatures - with time", async function () {
      var _await$pickFeatures2;
      geojson.setTrait(CommonStrata.definition, "url", "test/GeoJSON/time-based-automatic-styles.geojson");
      updateModelFromJson(geojson, CommonStrata.definition, {
        defaultStyle: {
          time: {
            timeColumn: "date",
            idColumns: ["idProperty"]
          }
        }
      });
      (await geojson.loadMapItems()).throwIfError();
      const imagery = geojson.mapItems[0];
      expect(imagery.imageryProvider instanceof ProtomapsImageryProvider).toBeTruthy();
      const spyOnProcessPickedFeatures = spyOn(imagery.imageryProvider, "pickFeatures").and.callThrough();
      const features = (_await$pickFeatures2 = await imagery.imageryProvider.pickFeatures(59166, 40202, 16, 2.5309053894540012, -0.6590723957845167)) !== null && _await$pickFeatures2 !== void 0 ? _await$pickFeatures2 : [];
      expect(spyOnProcessPickedFeatures).toHaveBeenCalledTimes(1);
      expect(features.length).toBe(1);
      expect(isTerriaFeatureData(features[0].data)).toBeTruthy();
      const terriaFeatureData = features[0].data;
      expect(terriaFeatureData.rowIds).toEqual([4, 5, 6, 7, 8]);
    });
    describe("applies default featureInfoTemplate", function () {
      let terria;
      let geojson;
      beforeEach(function () {
        terria = new Terria({
          baseUrl: "./"
        });
        geojson = new GeoJsonCatalogItem("test-geojson", terria);
      });
      it("removes _id_ from template", async function () {
        var _geojson$featureInfoT;
        geojson.setTrait(CommonStrata.user, "url", "test/GeoJSON/height.geojson");
        await geojson.loadMapItems();
        expect((_geojson$featureInfoT = geojson.featureInfoTemplate.template) === null || _geojson$featureInfoT === void 0 ? void 0 : _geojson$featureInfoT.indexOf("_id_")).toBe(-1);
      });
    });
  });
});